import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { EfiPaymentsConfigurationCard } from './components/efipayments-configuration-card'
import { EfiPaymentsDescriptorCard } from './components/efipayments-descriptor-card'
import { EfiPaymentsFeaturesCard } from './components/efipayments-features-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface EfiPaymentsProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const EfiPaymentsProcessorDetailsPage = ({ processor }: EfiPaymentsProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="efipayments"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <EfiPaymentsConfigurationCard processor={processor} />
            <EfiPaymentsDescriptorCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
            <EfiPaymentsFeaturesCard />
        </>
    )
}

